import _ from "lodash";
import store from "services/redux/store";
import { addData } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'

export default class FetchCachedTimeslotKinds
{
	static logName = 'FetchCachedTimeslotKinds';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'timeslotKinds',
				tables: [ 'timeslot_kinds' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchTimeslotKinds.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( timeslotKinds ) => {
						// Save to object
						this.process( timeslotKinds );


						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, timeslotKinds, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( timeslotKinds );
						}
					}
				})
			);
		}
		);
	}

	static process = ( timeslotKinds ) => {
		let timeslotKindsByKind = {};
		_.forEach( timeslotKinds, ( timeslotKind ) => {
			timeslotKindsByKind[ `${timeslotKind.kind}_${timeslotKind.sub_kind}` ] = timeslotKind;
		});
		
		this.values = timeslotKindsByKind;
		store.dispatch( addData( dataConstants.TIMESLOT_KINDS, timeslotKindsByKind ) );
	}
}
